<template>
	<div class="my-5" :key="question.quiz_uuid">
		<single-answer :question="question" v-if="question.type === QuestionTypes.SINGLE_QUESTION"></single-answer>
		<multiple-answer :question="question" v-else-if="question.type === QuestionTypes.MULTIPLE_QUESTION"></multiple-answer>
		<free-text :question="question" v-else-if="question.type === QuestionTypes.OPEN_QUESTION"></free-text>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MultipleAnswer from "./MultipleAnswer.vue";
import SingleAnswer from "./SingleAnswer.vue";
import FreeText from "./FreeText.vue"
import { QuestionPropMixin } from '@/utils/skill-assessment-mixins';
import { skillAssessmentConstants } from "@puls/puls-common-constants";

export default defineComponent({
	mixins: [QuestionPropMixin],
	data () {
		return {
			QuestionTypes: skillAssessmentConstants.SKILL_ASSESSMENT_QUESTIONS_TYPES
		}
	},
	components: {
		MultipleAnswer, SingleAnswer, FreeText
	}
})
</script>

<style scoped>

</style>
